export const GET_ENTITY_PERMISSION_REQUEST = 'GET_ENTITY_PERMISSION_REQUEST';
export const GET_ENTITY_PERMISSION_SUCCESS = 'GET_ENTITY_PERMISSION_SUCCESS';
export const GET_ENTITY_PERMISSION_FAILURE = 'GET_ENTITY_PERMISSION_FAILURE';

export const SET_ENTITY_PERMISSION_REQUEST = 'SET_ENTITY_PERMISSION_REQUEST';
export const SET_ENTITY_PERMISSION_SUCCESS = 'SET_ENTITY_PERMISSION_SUCCESS';
export const SET_ENTITY_PERMISSION_FAILURE = 'SET_ENTITY_PERMISSION_FAILURE';

export const RESET_ENTITY_PERMISSION = 'RESET_ENTITY_PERMISSION';
